const userInitialState = {
  _token:                    null,
  address:                   null,
  appealTypes:               [],
  appealInitialStateLoaded:  false,
  appealLoading:             false,
  appealWait:                false,
  authorized:                false,
  bookmarks:                 {},
  cityLabel:                 '',
  cities:                    [],
  email:                     null,
  form:                      {
    userId:       null,
    email:        null,
    login:        null,
    phone:        null,
    firstName:    null,
    lastName:     null,
    patronymic:   null,
    address:      null,
    cityId:       null,
    cityLabel:    null,
    regionId:     null,
    regionLabel:  null,
    countryId:    null,
    countryLabel: null,
    _token:       null,
  },
  isActive:                  null,
  loading:                   false,
  location:                  {
    cityId: null,
    label:  null,
  },
  locationLoading:           false,
  name:                      {
    first_name: null,
    last_name:  null,
    patronymic: null,
  },
  phone:                     null,
  possibleRoles:             [],
  probablyCity:              {
    cityId: null,
    label:  null,
  },
  profileInitialStateLoaded: false,
  regions:                   [],
  roles:                     [],
  tokenList:                 {},
  userInitialStateLoaded:    false,
  wait:                      false,
};

export default userInitialState;